<template>
  <a-modal class="report_content" :centered="true" :width="586" v-model="showModal" :footer="null" :closable="false">
    <div class="d-flex pt12">
      <font-awesome-icon class="error500 bg-error50 rounded-circle font30 p20" :icon="['fas', 'exclamation-triangle']" />
      <div class="ml-3 flex1">
        <h4 class="mb-3 text-capitalize font24 fw700 gray700">Delete {{ post ? (post.content_type === "press" ? "press release" : post.content_type) : "post" }}?</h4>
        <p class="mb-0 gray500 font16">
          Are you sure you want to delete this {{ post ? (post.content_type === "press" ? "press release" : post.content_type) : "post" }}? <br />
          You can’t undo this action.
        </p>
        <div class="mt-5 gap24 d-flex">
          <button :style="{ border: 'none' }" class="p1224 br6 bg-gray200 fw700 font14 gray600 ml-auto" @click="hide">Cancel</button>
          <button :style="{ border: 'none', background: getPrimaryColor() }" class="p1224 br6 fw700 font14 text-white" @click="deletePost">Delete</button>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory"

const PostRepository = RepositoryFactory.get("posts")

export default {
  name: "DeletePost",
  data() {
    return { showModal: false, post: null, profile: false, delApi1: false, delApi2: false }
  },
  methods: {
    show(data, fromProfilePolls = false) {
      console.log("show() -> fromProfilePolls:", fromProfilePolls)
      if (fromProfilePolls) {
        this.profile = true
      }
      this.showModal = true
      console.log("delete post -> data ->", data)
      this.post = data
    },
    hide() {
      this.showModal = false
    },
    async deletePost() {
      this.delApi1 = false
      this.delApi2 = false
      const payload = { is_deleted: true }
      try {
        switch (this.post.content_type) {
          case "poll":
            if (this.post.id) {
              try {
                PostRepository.deletePoll(this.post.id, payload).then(res => {
                  this.delApi1 = true
                  if (this.delApi2 && this.delApi1) {
                    this.$notification.success({ message: "Success", description: "Your poll has been deleted successfully" })
                    this.$router.go(0)
                  }
                })
                PostRepository.deleteActivityPoll(this.post.id, payload).then(res => {
                  this.delApi2 = true
                  if (this.delApi2 && this.delApi1) {
                    this.$notification.success({ message: "Success", description: "Your poll has been deleted successfully" })
                    this.$router.go(0)
                  }
                })
              } catch (e) {
                this.$notification.error({ message: "Error", description: "Your poll could not be deleted" })
              }
            }
            break
          case "post":
            PostRepository.deletePost(this.post.postId, payload)
              .then(res => {
                this.$notification.success({ message: "Success", description: `Your post has been deleted successfully` })
                this.$router.go(0)
              })
              .catch(err => {
                this.$notification.error({ message: "Error", description: "Your post could not be deleted" })
              })
            break
          case "question":
            if (this.post.id) {
              PostRepository.deleteActivityQuestion(this.post.id, payload)
                .then(res => {
                  PostRepository.deleteQuestion(this.post.id, payload).then(res => {
                    this.$notification.success({ message: "Success", description: "Your question has been deleted successfully" })
                    this.$router.go(0)
                  })
                })
                .catch(err => {
                  this.$notification.error({ message: "Error", description: "Your question could not be deleted" })
                })
            }
            break
          case "job":
            if (this.post.postId) {
              PostRepository.editJob(this.post.id, payload)
                .then(res => {
                  PostRepository.deletePost(this.post.postId, payload).then(res => {
                    this.$notification.success({ message: "Success", description: "Your job has been deleted successfully" })
                    this.$router.go(0)
                  })
                })
                .catch(err => {
                  this.$notification.error({ message: "Error", description: "Your job could not be deleted" })
                })
            }
            break
          case "press":
            if (this.post.postId) {
              PostRepository.editPressRelease(this.post.id, payload)
                .then(res => {
                  PostRepository.deletePost(this.post.postId, payload).then(res => {
                    this.$notification.success({ message: "Success", description: "Your press release has been deleted successfully" })
                    this.$router.go(0)
                  })
                })
                .catch(err => {
                  this.$notification.error({ message: "Error", description: "Your press release could not be deleted" })
                })
            }
            break
          case "event":
            if (this.post.postId) {
              PostRepository.editEvent(this.post.id, payload)
                .then(res => {
                  PostRepository.deletePost(this.post.postId, payload).then(res => {
                    this.$notification.success({ message: "Success", description: "Your event has been deleted successfully" })
                    this.$router.go(0)
                  })
                })
                .catch(err => {
                  this.$notification.error({ message: "Error", description: "Your event could not be deleted" })
                })
            }
            break
          default:
            this.$notification.error({ message: "Error", description: "Delete Failed" })
        }
      } catch (e) {}
      this.hide()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Modals/deletePostModal.vue